<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Pessoas Impedidas de Contratar
          <b-button
            size="sm"
            class="float-right m-1"
            to="/contratacao/novo-impedimento"
          >
            <font-awesome-icon icon="plus" class="mr-3" />
            Novo
          </b-button>
        </h6>
      </template>
      <b-card-body>
        <card-filtros-busca>
          <b-form
            @submit.prevent="buscarImpedidos"
            @reset.prevent="limparFiltros"
            v-if="showFilters"
          >
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  id="input-group-type"
                  label-size="md"
                  label="Nome"
                >
                  <b-form-input id="input-filtros-nome" v-model="filtros.nome">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  id="input-group-type"
                  label-size="md"
                  label="CPF/CNPJ"
                >
                  <b-form-input
                    id="input-filtros-cpfCnpj"
                    v-model="filtros.cpfCnpj"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  id="input-group-type"
                  label-size="md"
                  label="Tipo de Impedimento"
                >
                  <b-form-select
                    id="select-filtros-tipoDeImpedimento"
                    v-model="filtros.tipoDeImpedimento"
                    :options="comboTiposDeImpedimento"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  id="input-group-type"
                  label-size="md"
                  label="Suspenso"
                >
                  <b-form-select
                    id="select-filtros-suspenso"
                    v-model="filtros.suspenso"
                    :options="comboSuspenso"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col v-if="isTce" cols="12" md="6">
                <div id="ugSelectWrapper" class="wrapper-multiselect-sagres">
                  <b-form-group
                    id="input-group-type"
                    label-size="md"
                    label="Unidade Gestora"
                  >
                    <multiselect
                      v-model="ugSelecionada"
                      open-direction="bottom"
                      :placeholder="`SELECIONE`"
                      track-by="value"
                      :options="comboUgs"
                      :allow-empty="true"
                      label="text"
                      close-on-select
                      searchable
                      deselect-label=""
                      :show-labels="false"
                      @select="atualizaUGSelecionada"
                    />
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pt-4">
                <b-button type="submit" class="float-right ml-3">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
                <b-button
                  type="reset"
                  class="float-right"
                  variant="outline-secondary"
                >
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </card-filtros-busca>
        <b-table
          :busy="tableBusy"
          :fields="fields"
          hover
          no-border-collapse
          :items="items"
          sort-by=""
          :sort-desc="true"
          striped
          stacked="xl"
          per-page="0"
          :current-page="currentPage"
          show-empty
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons d-flex flex-column">
              <b-link class="text-dark" @click="detalhesImpedimento(row)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Detalhes</div>
              </b-link>
              <b-link class="text-dark" @click="editarImpedimento(row)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <div v-if="row.item.suspensao.FlAtivo">
                <b-link class="text-dark" @click="suspenderImpedimento(row)">
                  <font-awesome-icon icon="trash" />
                  <div style="font-size: 12px">Remover suspensão</div>
                </b-link>
              </div>
              <div v-else>
                <b-link class="text-dark" @click="suspenderImpedimento(row)">
                  <font-awesome-icon icon="ban" />
                  <div style="font-size: 12px">Suspender</div>
                </b-link>
              </div>
            </div>
          </template>
        </b-table>
        <table-pagination
          v-if="totalRows"
          :total-rows="totalRows"
          per-page="10"
          @pageChange="novaPaginaImpedidos"
        >
        </table-pagination>
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import impedidosService from "@/services/contratacao/impedidosService";
import { store } from "@/store";
import { FiltrosImpedidos } from "@/types/contratacao/filtros-impedidos";
import { Impedimentos } from "@/types/contratacao/impedimentos";
import { TableField } from "@/types/table-field";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import { fieldsImpedidos } from "@/types/contratacao/fields-impedidos";
import { SelectValue } from "@/types/select-value";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import Multiselect from "vue-multiselect";

const CompProps = Vue.extend({
  name: "ImpedidosDeContratar",
  components: { CardFiltrosBusca, TablePagination, Multiselect },
});

@Component
export default class ImpedidosDeContratar extends CompProps {
  fields: TableField[] = fieldsImpedidos;
  filtros: FiltrosImpedidos = new FiltrosImpedidos();
  items: Impedimentos[] = [];
  comboTiposDeImpedimento: SelectValue[] = [];
  comboSuspenso: SelectValue[] = [];
  totalRows = 0;
  showFilters = true;
  tableBusy = false;
  loadingPeriodos = false;
  ugSelecionada: SelectValue = { text: "SELECIONE", value: null };
  comboUgs: SelectValue[] = [];
  codUgLogado = store.codigoUG;

  //paginação
  currentPage = 1;

  get isTce(): boolean {
    return this.codUgLogado === "003101";
  }

  async mounted(): Promise<void> {
    try {
      store.blockScreen = true;
      this.filtros.limpar();
      await this.getCombos();
      await this.buscarImpedidos();
      if (this.isTce) {
        await this.getUnidadesGestoras();
      }
    } finally {
      store.blockScreen = false;
    }
  }

  async getCombos() {
    const combos = await impedidosService.getCombosConsultaImpedidos();

    this.comboTiposDeImpedimento = [
      { text: "SELECIONE", value: "", disabled: true },
      ...combos.tiposImpedimento.map((tp) => {
        return { text: tp.DeFundamento, value: tp.IdFundamento };
      }),
    ];

    this.comboSuspenso = [
      { text: "SELECIONE", value: "", disabled: true },
      { text: "Sim", value: "true" },
      { text: "Não", value: "false" },
    ];
  }

  novaPaginaImpedidos(page): void {
    this.currentPage = page;
    this.buscarImpedidos();
  }

  async buscarImpedidos(): Promise<void> {
    this.tableBusy = true;
    try {
      const response = await impedidosService.consultarImpedidos(
        this.filtros,
        this.currentPage,
      );
      if (response && response.status === 200) {
        this.items = response.data.impedimentos.map((pr: any) => {
          const retorno = new Impedimentos(pr);
          return retorno;
        });
        this.totalRows = response.data.totalRows;
      } else {
        throw new Error(
          response.data && response.data.msg
            ? response.data.msg
            : "Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!",
        );
      }
    } catch (e: any) {
      console.error(e);
      this.items = [];
      this.totalRows = 0;
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.tableBusy = false;
    }
  }

  async detalhesImpedimento(row) {
    this.$router.push(
      "/contratacao/detalhes-impedimento/" + row.item.IdImpedimento,
    );
  }

  async editarImpedimento(row) {
    this.$router.push(
      "/contratacao/editar-impedimento/" + row.item.IdImpedimento,
    );
  }

  async suspenderImpedimento(row) {
    this.$router.push(
      "/contratacao/suspender-impedimento/" + row.item.IdImpedimento,
    );
  }

  limparFiltros(): void {
    this.filtros.limpar();
    this.ugSelecionada = { text: "SELECIONE", value: null };
    this.showFilters = false;
    this.$nextTick(() => {
      this.showFilters = true;
    });
  }

  async getUnidadesGestoras(): Promise<void> {
    try {
      const ugs = await impedidosService.getUnidadesGestoras();

      this.comboUgs = [
        { text: "SELECIONE", value: "", disabled: true },
        ...ugs.map((ug) => {
          return { text: ug.NmNome, value: ug.CodUgSagres };
        }),
      ];
    } catch (e: any) {
      console.error("Erro ao obter lista de ugs...", e);
      throw e;
    }
  }

  atualizaUGSelecionada() {
    this.filtros.filtroUg = this.ugSelecionada.value as string;
  }
}
</script>

<style></style>
